import React, { useState, useEffect } from "react"
import { Box, Flex, Text, Inline } from '@sqymagma/elements'
import ModDashedLine from "./ModDashedLine"
import { formatNumberDot } from '../../../utils/formatNumber'
import { Facebook as SvgPlaceHolder } from 'react-content-loader'

export default ({fecha}) => {

    // Client-side Runtime Data Fetching
    // https://www.gatsbyjs.org/docs/data-fetching/
    const [topCountries, setTopCountries] = useState( null )
    const [europeCases, setEuropeCases] = useState( null )
    useEffect(() => {
    fetch(`https://covid19.secuoyas.io/api/v1/mod/eu?fecha=${fecha}`)
        .then(response => response.json()) // parse JSON from request
        .then(resultData => {
            setTopCountries(resultData && resultData.paises.slice(0,8) )
            setEuropeCases( resultData && resultData.europa)
        })
        .catch(err => console.log("Error getting data from API"))
    }, [fecha])


    return (
        topCountries && europeCases
        ? (
            <Box my="m" width={1}>
                <Inline justifyContent="space-between">
                <Flex alignItems="center" >
                    <Box width={1/2} mr="s" maxWidth="4rem">
                        <img src="/svg/map-europe.svg" alt="Europe icon"/>
                    </Box>
                    <Text textStyle="l">Europa</Text>
                </Flex>
                    {
                        <Inline alignItems="center">
                            {europeCases.casosConfirmados &&
                            <Text textStyle="xxl" mr="s">{formatNumberDot(europeCases.casosConfirmados)}</Text>}
                            <Text textStyle="l" color="brand05">Casos <br/>Confirmados</Text>
                        </Inline>
                    }
            </Inline>
            <ModDashedLine/>
            <Flex flexWrap="wrap" justifyContent="space-around" mt="m" ml="-8px" mr="-8px">
                {   
                    topCountries.map((el, idx) => (
                    <Box width={1/4} key={idx} mb="s" px="s">
                        <Box width="2rem">
                            <img src={`/svg/flags/${el.codigoIsoLugar.toLowerCase()}.svg`} alt={`${el.nombreLugar} flag icon`} />
                        </Box>
                        <Text as="p" textStyle="s" color="brand05">{el.nombreLugar.split("_").join(" ")}</Text>
                        <Text as="p" textStyle="s">{el.casosConfirmados && formatNumberDot(el.casosConfirmados)}</Text>
                    </Box>
                    ))
                }
            </Flex>
            </Box>  
            )
        : <SvgPlaceHolder/>
    )
}
